/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import carouselMixin from "./mixins/carousel-mixin";

const componentName = "related-from-retailer";

export default baustein.register(componentName, {
    componentName,
    mixins: [carouselMixin]
});

